import { useState, useEffect } from "react";
import client from './utils/sanity/client.ts';
import { Link, useParams } from "react-router-dom";
import BlockContent from "@sanity/block-content-to-react";
import { format } from "date-fns";
import EmbeddedContent from './EmbeddedContent'; // Import the new component
import './Book.css';
import { Helmet } from "react-helmet";
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function BookChapter() {

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const [singleChapter, setSingleChapter] = useState([])
  const { slug } = useParams()
  useEffect(() => {
    client.fetch(`*[slug.current == "${slug}"] {
      title,
      slug,
      chapter,
      body,
      publishedAt,
      mainImage {
        asset -> {
          _id,
          url
        },
        alt,
      },
      "name": author->name,
      youtubeVideo {
        url
      }
    }`).then((data) => setSingleChapter(data[0])).catch(console.error)
  }, [slug])
  return <>
    <div className="book-chapter-container">
      <Helmet>
        <title>Book - {slug}</title>
        <meta name="description" content="Check in here to read Aethel's latest chapter of her fantasy stories, inspired by fairytales and stories of old." />

        {/* Page-Specific Open Graph Tags */}
        <meta property="og:title" content="Chapter Page - Aethel Music" />
        <meta property="og:description" content="Check in here to read Aethel's latest chapter of her fantasy stories, inspired by fairytales and stories of old." />
        <meta property="og:image" content="%PUBLIC_URL%/images/TitleImageMedium.png" />
        <meta property="og:url" content="https://aethel.vercel.app/book/:slug" />

        {/* Page-Specific Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Chapter Page - Aethel Music" />
        <meta name="twitter:description" content="Check in here to read Aethel's latest chapter of her fantasy stories, inspired by fairytales and stories of old." />
        <meta name="twitter:image" content="%PUBLIC_URL%/images/TitleImageMedium.png" />
      </Helmet>
      <h1>{singleChapter.title}</h1>
      <section className="chapter-container">
        <div className="chapter-body-container">
          <h2 className="chapter-title">{singleChapter.chapter}</h2>
          <div className="chapter-image-date-container">
            {singleChapter.mainImage && singleChapter.mainImage.asset && (
              <LazyLoadImage src={singleChapter.mainImage.asset.url} alt={singleChapter.title} effect="blur" />
            )}

            {singleChapter.publishedAt && (
              <small>
                By {singleChapter.name} on{" "} {format(new Date(singleChapter.publishedAt), "dd MMMM yyyy")}
              </small>
            )}</div>
          <div className="body-text-container">
            <BlockContent
              blocks={singleChapter.body}
              projectId="pcafmc1n"
              dataset="production"
              className="custom-block-content-story"
            /></div>

        </div>
        <div className="video-frame">
          {singleChapter.youtubeVideo && (
            <div className="embedded-content-container">
              <EmbeddedContent url={singleChapter.youtubeVideo.url} />
            </div>
          )}
        </div>
        <Link to="/book"><button className="back-btn">Back</button></Link>
      </section>
    </div>
  </>
}
